export default __webpack_public_path__ + "static/media/inventory.d374559b.svg";